export default __webpack_public_path__ + "static/media/IMU.faf7cdcd.png";